<template>
  <div v-tooltip="tooltip" class="LmHelpTip" @click.stop>
    <v-popover ref="HTPopover">
      <lm-icon-button class="Icon" :icon="icon" svg svg-size="21" />
      <p slot="popover" class="mb-0">
        <slot />
        <a v-if="link" :href="link" target="_blank">{{ linkText }}</a>
      </p>
    </v-popover>
  </div>
</template>
<script>
import LmIconButton from '@/components/ui/LmIconButton'
export default {
  name: 'LmHelpTip',
  components: {
    LmIconButton
  },
  props: {
    icon: {
      type: String,
      default: 'info-outline'
    },
    link: {
      type: String,
      default: null
    },
    linkText: {
      type: String,
      default: 'More info'
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  methods: {
    hide() {
      this.$refs.HTPopover.hide()
    }
  }
}
</script>
